import React, { ReactNode } from 'react';
import {
  Box,
  Flex,
  HStack,
  Text,
  useColorModeValue,
  Container,
} from '@chakra-ui/react';

interface SimpleLayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
}

const SimpleLayout: React.FC<SimpleLayoutProps> = ({ children, title, subtitle }) => {
  const bg = useColorModeValue('gray.50', 'gray.900');
  const headerBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'white');

  return (
    <Flex direction="column" minH="100vh" bg={bg}>
      {/* Header */}
      <Flex
        as="header"
        align="center"
        justify="center"
        w="full"
        h="80px"
        bg={headerBg}
        borderBottom="1px solid"
        borderColor={borderColor}
        px="24px"
        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.04)"
        zIndex="docked"
      >
        <Box textAlign="center">
          {title && (
            <Text fontSize="xl" fontWeight="bold" color={textColor}>
              {title}
            </Text>
          )}
          {subtitle && (
            <Text fontSize="sm" color="gray.500" mt="-2px">
              {subtitle}
            </Text>
          )}
        </Box>
      </Flex>

      {/* Content Area */}
      <Box
        flex="1"
        overflow="auto"
        py="24px"
        css={{
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '3px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#a8a8a8',
          },
        }}
      >
        <Container maxW="100%" px="24px">
          {children}
        </Container>
      </Box>
    </Flex>
  );
};

export default SimpleLayout; 